<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Offers</h4>
        </div>
      </div>
    </div>
    <div class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <div class="space-y-16">
          <VList :meta="meta">
            <template #before>
              <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
                <div class="w-48 px-4">Issue Date</div>
                <div class="flex-1 px-4">Issuer</div>
                <div class="flex-1 px-4">Recipient</div>
                <div class="w-32 px-4 text-right">Ordered</div>
                <div class="w-32 px-4">Number</div>
                <div class="w-32 px-4 text-right mr-12">Amount</div>
              </div>
            </template>

            <template v-if="isLoading" #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                <Loader />
              </div>
            </template>

            <template v-else-if="isRejected" #default>
              <div
                class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center"
              >
                Something went wrong. Please try again later.
              </div>
            </template>

            <template v-else-if="offers.length" #default>
              <template v-for="offer in offers">
                <VListLine :key="`offers_${offer.uuid}`" :offer="offer" :disabled="isLoading" />
              </template>
            </template>

            <template v-else #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                No results found
              </div>
            </template>
          </VList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { merge } from 'lodash-es';
import store from '@/store';
import VListVue from '@/components/Common/VList.vue';
import ListLineVue from '@/components/Offers/ListLine.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  components: {
    VList: VListVue,
    VListLine: ListLineVue,
  },

  data() {
    return {
      status: STATUS_IDLE,
    };
  },

  watch: {
    $route: 'loadOffers',
  },

  computed: {
    offers() {
      return this.$store.state.ui.offers.ids
        .map((id) => this.$store.state.entities.offers.byId[id])
        .filter((o) => o);
    },
    meta() {
      return this.$store.state.ui.offers.meta;
    },
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  async beforeRouteEnter(to, from, next) {
    const { query } = to;
    const params = merge(query, { include: 'contact,offerLines,order,accountRelation' });

    try {
      await store.dispatch('ui/offers/load', {
        params,
      });
      next();
    } catch (error) {
      next(false);
    }
  },

  methods: {
    async loadOffers() {
      const { query } = this.$route;
      const params = merge(query, { include: 'contact,offerLines,order,accountRelation' });

      try {
        await store.dispatch('ui/offers/load', {
          params,
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
